import React, { useEffect, useState } from 'react';
import { toLowerCase } from '../utils/common_utils';
import { askAudioPermissions, getMicrophoneDevices, getMicrophonePermissions, monitorMicrophoneDeviceChanges, monitorMicrophonePermissionChanges } from './audio_utils';
import MicrophoneDropdown from './select_microphone';

/**
 * UI component to take audio permission to list all microphones available
 * fills all microphones in a dropdown select and 
 * calls back when any microphone is selected
 */
const AudioPermission = ({ microphoneSelectedCallback }) => {
  const [hasPermission, setHasPermission] = useState(false);
  const [deniedPermission, setDeniedPermission] = useState(false);
  const [deviceList, setDeviceList] = useState([]);
  const [selectedMicrophone, setSelectedMicrophone] = useState([]);

  function microphoneSelected(microphone){
    //console.log("inside microphone selected callback ")
    if(!microphone) return;
    //console.log(JSON.stringify(microphone))
    setSelectedMicrophone(microphone)
    if(microphoneSelectedCallback)
      microphoneSelectedCallback(microphone)
  }

  const fetchAudioPermissionState = async() => {
    try {
      const permission=await askAudioPermissions()
      //toLowerCase(await getMicrophonePermissions())
      console.log("audio permissions final state "+permission)
      setHasPermission(permission=='granted')
      setDeniedPermission(permission=='denied')
      if(permission=='granted')await fillDevicesList()  
    } catch (error) {
      console.log('Error fetching data:', error);
    }
  };

  const fillDevicesList = async() => {
    try{
    console.log("fill devices list called")
    const devices=await getMicrophoneDevices()
    console.log("fetched list of available devices , length "+devices.length)
    // if(devices) for(let i=0;i<devices.length;i++)console.log(JSON.stringify(devices[i]))
    if(devices && devices.length>0){
        setDeviceList(devices)
    }
  }catch(ex){
    console.log(ex)
  }
  };

  useEffect(() => {
    fetchAudioPermissionState()

    monitorMicrophonePermissionChanges(()=>{
        console.log("inside callbacks from utils, permissions changed")
        fetchAudioPermissionState()
  })

    monitorMicrophoneDeviceChanges(audioDevices=>{
        console.log("got list of devices in callback "+audioDevices.length)
        setDeviceList(audioDevices)})
        
    return () => {
    // put any cleanup code here
    };
  }, []);

  const requestPermissions = async () => {
    console.log("requesting permissions")
   await fillDevicesList();
  };

  return (
    <div className=" flex flex-col justify-center items-center
     border rounded-xl">
      {
        //********* device list row started   *************
      hasPermission && (
       <div className='bg-white text-gray-800'>
        <MicrophoneDropdown deviceList={deviceList} 
        microphoneSelected={microphoneSelected} />
        </div>
      )
      //********* device list row ended   *************
      }
      
      {
        //********* give permissions row started   *************
      !hasPermission && !deniedPermission &&
      <div className="text-center">
        <button
            onClick={requestPermissions}
            className="px-4 py-2 text-white
             bg-purple-500 rounded-md
              hover:bg-purple-600">
            Give Microphone Permissions
          </button>
          <p className="mt-2 text-sm text-purple-700 mx-4 ">
            Please give Audio Permissions to talk to AI Interviewer.
          </p>
          
        </div>
    // ********* give permissions row ended   *************
    }

    { // ********* denied permissions row starts   *************
    deniedPermission &&
      <div>
        You have denied audio permissions. <br />
        Please grant them from browser settings. 
        <br />
        
        </div>  
    // ********* denied permissions row ends   *************
    }



    </div>
  );
};

export default AudioPermission;
